import type { ColorPalette } from 'config/theme/types';

export const zdfKikaColors: Partial<ColorPalette> = {
    // Text
    colorTextPrimary: '#FFFFFF',
    colorTextSecondary: '#BFCFD5',
    colorTextSecondaryOnBanner: '#FFFFFF',
    colorTextDisabled: '#53697E',
    colorTextHint: '#82A3C2',
    colorTextAccent: '#2BE8BC',
    colorTextWarning: '#FD6570',
    colorTextSuccess: '#B9EBDC',
    colorTextOnPrimaryButton: '#14334D',
    colorTextOnAccentColorBg: '#14334D',
    colorTextOnEntryPointColorBg: '#FEBE00',
    colorTextOnTagLight: '#000000',
    colorTextOnToastDark: '#000000',
    colorTextOnDataVizCategory: '#FFFFFF',
    colorTextOnTeaserButton: '#14334D',

    // Button
    colorButtonPrimary: '#2BE8BC',
    colorButtonAccent: '#2BE8BC',
    colorButtonSecondary: '#175159',
    colorButtonDisabled: '#151F2C',
    colorButtonSliderThumb: '#2BE8BC',
    colorButtonTeaser: '#2BE8BC',

    // Surface
    colorSurfacePrimary: '#122B40',
    colorSurfaceSecondary: '#0C1F35',
    colorSurfaceHighlight: '#2C5B86',
    colorSurfaceHighlightShade1: '#151F2C',
    colorSurfaceHighlightShade2: '#0F0F0F',
    colorSurfaceBannerWarning: '#151F2C',
    colorSurfaceBannerSuggestion: '#151F2C',
    colorSurfaceBannerSuccess: '#151F2C',
    colorSurfaceBannerInfo: '#151F2C',
    colorSurfaceUserBlock: '#FA7355',
    colorSurfaceUserWarning: '#FFE6B4',
    colorSurfaceUserUnblock: '#2BE8BC',
    colorSurfaceUserVerified: '#CDE1FF',
    colorSurfacePopoverDark: '#FFFFFF',
    colorSurfaceToggleBackground: '#FFFFFF33',

    // Tag
    colorTagDefault: '#457DAC',
    colorTagAccent: '#2BE8BC',
    colorTagAccentLight: '#23AF97',
    colorTagHighlight: '#FCEBEA',
    colorTagWarning: '#FCEBEA',
    colorTagSuccess: '#B9EBDC',
    colorTagVerified: '#CDE1FF',
    colorTagWhite: '#FFFFFF',

    // Border
    colorBorderPrimary: '#AAF6E4',
    // TODO: This should be White at 15% - 15 is not 15%, it is roughly 8%. 15%
    // would be 26
    colorBorderPrimaryOnBanner: '#FFFFFF15',
    colorBorderSelected: '#53697E',
    colorBorderAccent: '#00BEB7',
    colorBorderAccentLight: '#ECECFF',
    colorBorderWarning: '#FD6570',
    colorBorderFace: '#4F596E',
    colorBorderSliderThumb: '#2BE8BC',
    colorBorderDataVizBar: '#0F0F0F',

    // DataViz
    colorDataVizScale1: '#2BE8BC',
    colorDataVizScale2: '#7D7DFF',
    colorDataVizScale3: '#145157',
    colorDataVizOther: '#21537D',
    colorDataVizCategory1: '#525DCF',
    colorDataVizCategory2: '#BE73CD',
    colorDataVizCategory3: '#763A35',
    colorDataVizCategory4: '#A57328',
    colorDataVizCategory5: '#F56400',

    // Entry point colors
    colorEntryPointColorGreen: '#0C1F35',
    colorEntryPointColorGreenTint: '#21537D',
};

export const zdfKikaAvatarColors: string[] = ['#BFF800', '#FF3388', '#FFD403', '#17F3FF', '#F478BC', '#A188FC'];
